import React from "react";
import Spinner from "@/components/spinner.tsx";

export default function LazyPageLoader() {
    return   <div className={"d-flex items-center justify-content-center"} style={{paddingTop:100, paddingBottom:100}}>
        <Spinner /></div>;
}
